import usePostHogIdentify from 'utils/postHogAnalytics/usePostHogIdentify';

const AnalyticsIdentify = () => {
  usePostHogIdentify();

  return null;
};

export default AnalyticsIdentify;
